import { Box, Card } from '@mui/material';
import { MapComponent } from '../View/map';

interface MapComponentContainerProps {
  latitude: number;
  longitude: number;
  useWrapper?: boolean;
  height?: string;
}

export const MapComponentContainer = ({ 
  latitude, 
  longitude,
  useWrapper = true,
  height = '400px'
}: MapComponentContainerProps) => {
  const MapContent = (
    <Box sx={{ width: '100%', height }}>
      <MapComponent 
        latitude={latitude} 
        longitude={longitude} 
        width="100%" 
        height="100%" 
      />
    </Box>
  );

  if (!useWrapper) {
    return MapContent;
  }

  return (
    <Card sx={{ 
      width: '100%', 
      mt: 2, 
      borderRadius: 2, 
      overflow: 'hidden', 
      boxShadow: 1 
    }}>
      {MapContent}
    </Card>
  );
};